import axios from 'api/axios'

/**
 * API call create subscribe webhook in case of vendor is PINNACLE
 * @param id string - client id
 * @returns NA
 */

const subscribeWebhook = async (id: string): Promise<any> => {
	const environment: string = process.env.REACT_APP_EDGE_MODE || 'STAGING'

	const body = {
		url: `https://${
			environment === 'STAGING'
				? 'webhookstaging.whatcx.com'
				: 'webhook.whatcx.com/'
		}/v1/webhook/pinnacle/${id}`,
		webhookToken: `${id}`,
	}
	const response = await axios.post(`v1/client/webhook/${id}`, body)
	return response.data
}
export default subscribeWebhook
